import { brasilApi } from "./brasilApi.api";

export const { useGetIbgeUFQuery, useLazyGetCepV2Query, useLazyGetCnpjQuery } = brasilApi;
